'use client';

import { type ReactElement, useState } from 'react';
import { cn } from '@fshr/shared-react';
import BevSafeText from '../bev-safe-text';
import AccordionItem from './accordion-item';
import type { Props } from './types';

const MIN_ITEMS = 2;
const MAX_ITEMS = 6;

export default function StackedAccordion({
	title,
	items,
	id,
	className,
}: Props): ReactElement | null {
	const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

	const visibleItems = items.slice(0, MAX_ITEMS);
	if (visibleItems.length < MIN_ITEMS) {
		return null;
	}

	const toggle = (index: number) => setExpandedIndex(prev => (prev === index ? null : index));

	return (
		<section className={cn('w-full spacing-wide-grid', className)}>
			{title && (
				<h2 id={id} className="text-h2 text-text-heading line-clamp-2 mb-heading-m">
					<BevSafeText>{title}</BevSafeText>
				</h2>
			)}
			<div>
				{visibleItems.map((item, index) => (
					<AccordionItem
						key={index}
						question={item.question}
						answer={item.answer}
						isExpanded={expandedIndex === index}
						isFirst={index === 0}
						onToggle={() => toggle(index)}
					/>
				))}
			</div>
		</section>
	);
}
